import logo from './logo.svg';
import './App.css';
import IncomeTaxCalculator from './components/IncomeTaxCalculator';

function App() {
  return (
    <div className="App">
        
      <IncomeTaxCalculator/>
    </div>
  );
}

export default App;
